import React from 'react';
import { IconEmoticonSad } from '../icons/emoticon-sad';
import { GapSizeType } from '../../../theme/type/gap-type';
import { cn, marginBottomClass } from '../../../utils/tailwind';

interface NoDataPropsInterface {
    children: React.ReactNode;
    action?: React.ReactNode;
    fullWidth?: boolean;
    footer?: React.ReactNode;
    marginBottom?: GapSizeType;
    compact?: boolean;
}

export const NoData: React.FC<NoDataPropsInterface> = ({
    children,
    action,
    fullWidth,
    footer,
    marginBottom = 'xlarge',
    compact = false,
}: NoDataPropsInterface) => {
    return (
        <div
            className={cn(
                'rounded-large border border-dashed border-border text-center font-medium',
                compact
                    ? 'flex h-full min-h-0 flex-col justify-center p-medium text-medium'
                    : 'p-xlarge px-medium text-large',
                marginBottomClass[marginBottom],
                fullWidth && 'w-full',
            )}
        >
            <div
                className={cn(
                    '[&_i]:text-neutral-gray [&_i]:drop-shadow-[-1px_-1px_0_rgba(0,0,0,0.15)]',
                    compact ? 'mb-small [&_i]:h-[6rem] [&_i]:w-[6rem]' : 'mb-medium [&_i]:h-[12rem] [&_i]:w-[12rem]',
                )}
            >
                <IconEmoticonSad />
            </div>
            <div className="text-neutral-gray font-bold leading-[1.4]">{children}</div>
            {action && <div className="mt-vlarge inline-flex flex-wrap justify-center gap-small">{action}</div>}
            {footer && <div className="mt-vlarge flex justify-center gap-small">{footer}</div>}
        </div>
    );
};
